import { Component, OnInit } from '@angular/core';
import { CpAuthenticationService } from '../../services/cp-authentication.service';
import { CpMarketplaceApiService } from '../../services/cp-marketplace-api.service';
import { SharedDataService } from '../../services/shared-data.service';
import { Router } from '@angular/router';
import { UserProfile } from 'appRootPath/models/commercial-papers.model';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  domainName = '';
  tncDisabled: Boolean = true;
  constructor(
    private cpAuthService: CpAuthenticationService,
    private cpApiService: CpMarketplaceApiService,
    public sharedDataService: SharedDataService,
    private router: Router
  ) {

  }

  ngOnInit() {

    this.tncDisabled = true;
    if (this.sharedDataService.getUserDataFromLS() &&
      this.sharedDataService.getUserDataFromLS().auth_details.tnc_signed === true) {
      this.router.navigate(['/user-role/']);
    }
    this.domainName = window.location.host;
  }

  onTncScroll(event) {
    if (parseInt(event.srcElement.offsetHeight + event.srcElement.scrollTop, 10) > (parseInt(event.srcElement.scrollHeight, 10) - 30)) {
      this.tncDisabled = false;
    } else {
      this.tncDisabled = true;
    }
  }

  onTncChange(event) {
    if (event.currentTarget.checked) {
      this.cpApiService.updateUserTnc(
        this.sharedDataService.getUserDataFromLS().auth_details.id, true
      ).subscribe((successResp: UserProfile) => {
        if (successResp.tnc_signed) {
          this.router.navigate(['/user-role/']);
        } else {
          this.router.navigate(['login']);
        }
      });
    }
  }

  logoutAndGoToLogin() {
    this.cpApiService.updateUserTnc(
      this.sharedDataService.getUserDataFromLS().user_id,
      false
    ).subscribe((resp) => {
      this.cpAuthService.logout(true);
    });
  }

}
